"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var PlaceStyles_1 = require("../../style/PlaceStyles");
var UIActionsContext_1 = require("../../uiActions/UIActionsContext");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var DataQualityWarningDatabases_1 = require("../DataQualityWarnings/DataQualityWarningDatabases");
var DatabaseIcon_1 = require("../icons/DatabaseIcon");
var PlaceHeaderMetadataCertification_1 = require("../placePage/PlaceHeaderMetadataCertification");
var PlaceHeaderMetadataTableauUser_1 = require("../placePage/PlaceHeaderMetadataTableauUser");
var PlacePageIconContainer_1 = require("../placePage/PlacePageIconContainer");
var CreateWorkbookFromCatalogButtons_1 = require("../TablePlacePage/CreateWorkbookFromCatalogButtons");
function DatabasePlacePageHeader(props) {
    var uiActions = React.useContext(UIActionsContext_1.UIActionsContext);
    var siteUrls = React.useContext(SiteUrlsContext_1.SiteUrlsContext);
    var canCreateWorkbookFromDatabase = props.apiRequests.isSiteCreatorOrHigher() && !!props.newWorkbookFromCatalog;
    return (React.createElement(PlaceStyles_1.PlacePageHeader, null,
        React.createElement(PlaceStyles_1.PlacePageTitleContainer, null,
            React.createElement(PlacePageIconContainer_1.PlacePageIconContainer, { title: DatabaseIcon_1.getDatabaseIconTooltip(props.database) },
                React.createElement(DatabaseIcon_1.DatabaseMastheadIcon, { database: props.database })),
            React.createElement(PlaceStyles_1.PlacePageMastheadContainer, null,
                React.createElement(PlaceStyles_1.PlacePageMastheadRowContainer, null,
                    React.createElement(PlaceStyles_1.PlacePageTitle, { title: props.database.name || undefined }, props.database.name),
                    React.createElement(PlaceStyles_1.PlacePageActionsMenu, null, uiActions.renderDatabasesActionMenu(props.database))),
                React.createElement(PlaceStyles_1.PlacePageMastheadRowContainer, null,
                    React.createElement(DatabaseContact, { database: props.database }),
                    React.createElement(DatabaseCertifier, { database: props.database, siteUrls: siteUrls }),
                    React.createElement(DataQualityWarningDatabases_1.QueryDatabaseOwnDataQualityWarnings, { nodeId: props.database.id })))),
        canCreateWorkbookFromDatabase &&
            React.createElement(CreateWorkbookFromCatalogButtons_1.CreateWorkbookFromDatabaseButton, { apiRequests: props.apiRequests, database: props.database, siteUrls: siteUrls })));
}
exports.DatabasePlacePageHeader = DatabasePlacePageHeader;
function DatabaseContact(props) {
    return (React.createElement(PlaceStyles_1.PlaceHeaderMetadataItem, null,
        React.createElement(PlaceHeaderMetadataTableauUser_1.PlaceHeaderMetadataTableauUser, { tableauUser: props.database.contact, labelText: Localize_1.Messages.GridHeaderContact() })));
}
function DatabaseCertifier(props) {
    return (React.createElement(PlaceStyles_1.PlaceHeaderMetadataItem, null,
        React.createElement(PlaceHeaderMetadataCertification_1.PlaceHeaderMetadataCertification, { contentId: props.database.id, certification: props.database, siteUrls: props.siteUrls, showExtractRefresh: false })));
}
//# sourceMappingURL=DatabasePlacePageHeader.js.map